import React from 'react';
import { Tooltip, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import type { SupplierOrderItemDto } from '../../../dto/supplierOrder';
import { formatProductDimensions } from '../../../utils/productDimensions';
import { formatSupplierOrderQuantity } from '../supplierOrderUnits';
import './SupplierOrderProductsPreview.css';

const EMPTY_VALUE = '-';

interface SupplierOrderProductsPreviewProps {
  items?: SupplierOrderItemDto[];
}

const SupplierOrderProductsPreview: React.FC<SupplierOrderProductsPreviewProps> = ({ items }) => {
  const { t, i18n } = useTranslation(['orders']);

  if (!items?.length) {
    return <Typography.Text type="secondary">{EMPTY_VALUE}</Typography.Text>;
  }

  return (
    <div className="supplier-order-products-preview">
      {items.map((item, index) => {
        const dimensions = formatProductDimensions(item);

        return (
          <div key={item.id || `${item.name}-${index}`} className="supplier-order-products-preview__item">
            <div className="supplier-order-products-preview__copy">
              <Tooltip title={item.name}>
                <span className="supplier-order-products-preview__name">{item.name}</span>
              </Tooltip>
              {dimensions ? (
                <span className="supplier-order-products-preview__dimensions">
                  {dimensions}
                </span>
              ) : null}
            </div>
            <span className="supplier-order-products-preview__quantity">
              {item.quantity != null
                ? formatSupplierOrderQuantity(item, t, i18n.language)
                : EMPTY_VALUE}
            </span>
          </div>
        );
      })}
    </div>
  );
};

export default SupplierOrderProductsPreview;
